'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactChartjs = require('react-chartjs-2');

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var greenText = { color: '#20c49e', fontWeight: 'bold' };
var redText = { color: 'red', fontWeight: 'bold' };

var leftBlockStyle = {
  paddingTop: 40
};

var avatarStyle = {
  margin: '0 auto',
  display: 'block'
};

var GRAPH_DAYS_TO_RENDER = 7;

var getVideosDuration = function getVideosDuration(videos) {
  //
  var regex = /([0-9]{1,2}h)?([0-9]{1,2}m)?([0-9]{1,2}(\.[0-9]{1,3})?s)?/i;
  var durations = _lodash2.default.map(videos, 'duration');

  var result = _lodash2.default.map(durations, function (duration) {
    var matches = duration.match(regex);
    return {
      hours: matches[1],
      minutes: matches[2],
      seconds: matches[3]
    };
  });

  var duration = _moment2.default.duration();

  _lodash2.default.forEach(result, function (item) {
    if (item.hours) {
      duration.add(_lodash2.default.toNumber(_lodash2.default.replace(item.hours, 'h', '')), 'hours');
    }
    if (item.hours) {
      duration.add(_lodash2.default.toNumber(_lodash2.default.replace(item.minutes, 'm', '')), 'minutes');
    }
    if (item.hours) {
      duration.add(_lodash2.default.toNumber(_lodash2.default.replace(item.seconds, 's', '')), 'seconds');
    }
  });

  return duration;
};

var generateChartData = function generateChartData(records, countHistory, meanFollowersCount, lastestFollowersCount) {
  return {
    labels: _lodash2.default.times(GRAPH_DAYS_TO_RENDER, function (n) {
      return (0, _moment2.default)().subtract(n + 1, 'days').format('MMM DD');
    }).reverse(),
    datasets: [{
      label: 'Stream Hours',
      data: _lodash2.default.times(GRAPH_DAYS_TO_RENDER, function (n) {
        var date = (0, _moment2.default)().subtract(n + 1, 'days');
        var videos = _lodash2.default.filter(records, function (record) {
          return (0, _moment2.default)(record.created_at).isSame(date, 'day');
        });
        if (_lodash2.default.isEmpty(videos)) {
          return 0;
        }
        var duration = getVideosDuration(videos);
        return duration.asHours();
      }).reverse(),
      fill: true,
      backgroundColor: 'rgba(75,192,192,0.2)',
      borderColor: 'rgba(75,192,192,1)',
      yAxisID: 'y-axis-1'
    }, {
      label: 'Followers',
      data: _lodash2.default.times(GRAPH_DAYS_TO_RENDER, function (n) {
        var date = (0, _moment2.default)().subtract(n + 1, 'days');
        var history = _lodash2.default.find(countHistory, function (record) {
          return (0, _moment2.default)(record.createdDate).isSame(date, 'day');
        });
        return _lodash2.default.get(history, 'twitchCount', meanFollowersCount || lastestFollowersCount);
      }).reverse(),
      fill: true,
      backgroundColor: 'rgba(154, 18, 179, 0.2)',
      borderColor: 'rgba(154, 18, 179, 1)',
      yAxisID: 'y-axis-2'
    }]
  };
};

var options = {
  tooltips: {
    callbacks: {
      label: function label(tooltipItem, data) {
        var shouldRenderHours = _lodash2.default.get(tooltipItem, 'datasetIndex') === 0;
        return '' + (0, _formatting.sciFormatted)(_lodash2.default.get(tooltipItem, 'yLabel'), '0') + (shouldRenderHours ? 'h' : '');
      }
    }
  },
  legend: {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  },
  scales: {
    yAxes: [{
      type: 'linear',
      display: true,
      position: 'left',
      id: 'y-axis-1',
      ticks: {
        callback: function callback(label) {
          return (0, _formatting.commaFormatted)(label, 0) + 'h';
        }
      }
    }, {
      stepSize: 100000,
      type: 'linear',
      display: true,
      position: 'right',
      id: 'y-axis-2',
      ticks: {
        callback: function callback(label) {
          return (0, _formatting.sciFormatted)(label);
        }
      },
      gridLines: {
        drawOnArea: false
      }
    }]
  }
};

var LoadingChart = function LoadingChart() {
  return _react2.default.createElement(
    'div',
    { style: { minHeight: 330 } },
    _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading Twitch data...' })
  );
};

var ErrorChart = function ErrorChart() {
  return _react2.default.createElement(
    'div',
    { style: { minHeight: 330 } },
    _react2.default.createElement(
      _semanticUiReact.Message,
      { color: 'orange' },
      'Twitch data is unavailable now. Please try again later'
    )
  );
};

var TwitchData = function (_React$Component) {
  (0, _inherits3.default)(TwitchData, _React$Component);

  function TwitchData(props) {
    (0, _classCallCheck3.default)(this, TwitchData);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TwitchData.__proto__ || (0, _getPrototypeOf2.default)(TwitchData)).call(this, props));

    _this.state = {
      loading: true,
      data: null,
      failed: false
    };
    return _this;
  }

  (0, _createClass3.default)(TwitchData, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var handle, response, data;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                handle = _lodash2.default.get(this.props, 'influencer.twitch');

                if (!handle) {
                  this.setState({
                    loading: false
                  });
                }
                _context.next = 4;
                return _axios2.default.get('https://jniyllb4b5.execute-api.eu-west-1.amazonaws.com/production/twitch-videos/data?handle=' + handle);

              case 4:
                response = _context.sent;

                if (_lodash2.default.has(response, 'data.videos')) {
                  data = _lodash2.default.get(response, 'data', {});

                  this.setState({
                    data: data,
                    loading: false,
                    failed: false
                  });
                } else {
                  this.setState({
                    failed: true,
                    loading: false
                  });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var influencer = this.props.influencer;

      var username = _lodash2.default.get(influencer, 'twitch');

      if (!username) {
        return null;
      }

      var twitchCount = _lodash2.default.get(influencer, 'twitchCount');
      var countHistory = _lodash2.default.get(influencer, 'countHistory', []);

      var videos = _lodash2.default.get(this.state, 'data.videos', []);
      var thumbnail = _lodash2.default.get(this.state, 'data.thumbnail');
      var streamStats = _lodash2.default.get(this.state, 'data.stream_stats');
      var loading = _lodash2.default.get(this.state, 'loading');
      var failed = _lodash2.default.get(this.state, 'failed');

      var allDaysPeak = _lodash2.default.max(_lodash2.default.map(videos, 'view_count'));

      var sevenDaysData = _lodash2.default.filter(videos, function (item) {
        return (0, _moment2.default)(item.created_at).isSameOrAfter((0, _moment2.default)().subtract(6, 'days'), 'day');
      });

      var sevenDaysDuration = getVideosDuration(sevenDaysData);
      var allDataDuration = getVideosDuration(videos);

      var sevenDaysPeak = _lodash2.default.max(_lodash2.default.map(sevenDaysData, 'view_count'));
      var sevenDayAvg = _lodash2.default.mean(_lodash2.default.map(sevenDaysData, 'view_count'));

      var sortedHistory = _lodash2.default.orderBy(countHistory, 'createdDate');

      var meanFollowersCount = _lodash2.default.meanBy(_lodash2.default.filter(sortedHistory, function (history) {
        return (0, _moment2.default)(_lodash2.default.get(history, 'createdDate')).isSameOrAfter((0, _moment2.default)().subtract(6, 'days'), 'day');
      }), 'twitchCount');

      var oldestHistoryItem = _lodash2.default.find(sortedHistory, function (item) {
        return _lodash2.default.has(item, 'twitchCount');
      });
      var newestHistoryItem = _lodash2.default.findLast(sortedHistory, function (item) {
        return _lodash2.default.has(item, 'twitchCount');
      });
      var lastestFollowersCount = _lodash2.default.get(newestHistoryItem, 'twitchCount');

      var followersChange = _lodash2.default.subtract(_lodash2.default.get(newestHistoryItem, 'twitchCount', 0), _lodash2.default.get(oldestHistoryItem, 'twitchCount', 0));

      var isPositiveChange = followersChange > 0;

      var chartData = generateChartData(videos, countHistory, meanFollowersCount, lastestFollowersCount);

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { color: 'purple' },
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', color: 'purple' }),
          ' Twitch'
        ),
        _react2.default.createElement(_semanticUiReact.Divider, null),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            loading && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: '16' },
              _react2.default.createElement(LoadingChart, null)
            ),
            failed && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: '16' },
              _react2.default.createElement(ErrorChart, null)
            ),
            !loading && !failed && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: '3', textAlign: 'center', style: leftBlockStyle },
              _react2.default.createElement(_semanticUiReact.Image, {
                className: 'circular',
                size: 'small',
                style: avatarStyle,
                src: thumbnail
              }),
              _react2.default.createElement(
                _semanticUiReact.Table,
                { basic: 'very', fluid: true, textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      username
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      (0, _formatting.commaFormatted)(twitchCount),
                      ' followers'
                    )
                  )
                )
              )
            ),
            !loading && !failed && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: '8' },
              _react2.default.createElement(_reactChartjs.Line, { data: chartData, options: options })
            ),
            !loading && !failed && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: '5' },
              _react2.default.createElement(
                _semanticUiReact.Table,
                { basic: 'very' },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 2 },
                      'Last 7 Days'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      'Hours streamed'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      (0, _formatting.commaFormatted)(sevenDaysDuration.asHours()),
                      ' hours'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      'Average viewers'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      streamStats ? streamStats.sevenDaysAvg : '-'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      'Peak viewers'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      streamStats ? streamStats.sevenDaysPeak : '-'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table,
                { basic: 'very' },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 2 },
                      'Last 30 Days'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      'Follower change'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { style: isPositiveChange > 0 ? greenText : redText },
                      ' ',
                      isPositiveChange ? '+' : '',
                      followersChange
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      'Peak viewers'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      streamStats ? streamStats.thirtyDaysPeak : '-'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      'Hours streamed'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      (0, _formatting.commaFormatted)(allDataDuration.asHours()),
                      ' hours'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TwitchData;
}(_react2.default.Component);

TwitchData.propTypes = {
  influencer: _propTypes2.default.object.isRequired
};

exports.default = TwitchData;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/twitch-data/index.js
 ** module id = 599
 ** module chunks = 0
 **/